import {
  DropzoneReadonly,
  FiFileText,
  GridItem,
  ReadOnlyField,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import {
  formatDateToShortFormat,
  unixTimestampToDate,
} from '@bcba/common-utils';
import { DocumentSerializer } from '@bcba/serializers';
import { downloadDocument } from '../../utils/downloadDocument.utils';

interface Props {
  label: string;
  document?: DocumentSerializer;
  showExtendedFields?: boolean;
  expirationDateHelperText?: string;
}

export const ReadOnlyDocumentSection = ({
  label,
  document,
  showExtendedFields = true,
  expirationDateHelperText,
}: Props) => {
  const { t } = useTranslation();
  const { uuid, originalFileName, identifier, expirationDate } = document ?? {};
  return (
    <>
      <GridItem colSpan={{ base: 1, md: 2 }}>
        <DropzoneReadonly
          label={label}
          fileName={originalFileName ?? t('common.toBeUploadedByBolsa')}
          onClick={() => uuid && downloadDocument(uuid)}
          leftIcon={FiFileText}
        />
      </GridItem>
      {showExtendedFields && (
        <>
          <ReadOnlyField
            label={t('common.documentIdentifier')}
            value={identifier ?? t('common.toBeCompletedByBolsa')}
          />
          <ReadOnlyField
            label={t('common.dueDate')}
            value={
              expirationDate
                ? formatDateToShortFormat(unixTimestampToDate(expirationDate))
                : t('common.toBeCompletedByBolsa')
            }
            helperText={expirationDateHelperText}
          />
        </>
      )}
    </>
  );
};
